export default __webpack_public_path__ + "static/106-ff58937ce71cb8c6ddb9eb0e998e44d6.gif";